import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger
} from '@angular/animations';

const duration = '800ms';


export const expandTabsAnimation = trigger('expandTabsAnimation', [

	transition('false => true', [

		group([
			style({ height: 0, opacity: 1}),
			animate(duration + ' ease-in-out', style({ height: '*', opacity: 1 })),
			query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
		])
    
  ]),
  transition('true => false', [

  	group([
  		style({ height: '*'}),
  		animate(duration + ' ease-in-out', style({ height: 0 })),
  		query('@*', [
          animateChild()
      ],
      	{ optional: true }
      )
  	]),
  	style({ height: '0px', opacity: 0}),

    
  ]),
  state( 'false', style({ height: '0px', opacity: 0 })),
  state( 'true', style({ height: '*', opacity: 1 }))


]);
